<template>
  <div class="lesson-window">
    <!-- eslint-disable-next-line max-len -->
    <v-progress-linear
      v-if="loading || rendering || (initialLoading && currentLink)"
      indeterminate
      color="primary"
    ></v-progress-linear>
    <div id="keynote" v-if="isKeynote">
      <!-- eslint-disable-next-line max-len -->
      <pdf
        :page="page"
        @loaded="dismissInitialLoading"
        @num-pages="findOut"
        :src="currentLink"
        v-if="currentLink && isPdf"
      ></pdf>
      <img class="lesson-window--image" v-else-if="currentLink && isImage" :src="link" />
      <iframe
        v-else-if="currentLink && isWebsite && isRenderableWebsite"
        :src="ensureFormat"
        frameborder="0"
      ></iframe>
      <lesson-window-alert
        :message="link"
        :link="link"
        v-else-if="currentLink && isWebsite && !isRenderableWebsite"
      ></lesson-window-alert>
      <lesson-window-alert :message="$t('keynoteOff')" v-else-if="!rendering"></lesson-window-alert>
    </div>
    <div v-else>
      <iframe
        :src="`https://attendu-stream.web.app/?room=${room}`"
        allow="microphone; camera"
        frameborder="0"
        id="stream"
        v-if="live"
      ></iframe>
      <!-- eslint-disable-next-line max-len -->
      <lesson-window-alert :message="$t('cameraOff')" v-else></lesson-window-alert>
      <!-- reconnect button -->
      <div class="lesson-window__reconnect mt-1"
            v-if="isTeacher || isViewerConnected"
            @click="emitReconnect">
        <v-row justify="center">
          <v-icon class="lighten lesson-window__reconnect-icon"
          :class="{'lesson-window__reconnect-icon--rotate' : reconnecting }">
          mdi-refresh</v-icon>
          <p class="lighten ps-1">Obnovit připojení</p>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import pdf from 'vue-pdf/src/vuePdfNoSss.vue';
import lessonWindowAlert from '@/components/LessonWindowAlert.vue';

export default {
  components: {
    pdf,
    lessonWindowAlert,
  },
  data() {
    return {
      currentLink: this.link,
      rendering: false,
      initialLoading: false,
      reconnecting: false,
    };
  },
  watch: {
    page() {
      this.trackRender();
    },
    link(newLink) {
      this.currentLink = '';
      this.rendering = true;
      setTimeout(() => {
        this.rendering = false;
        this.currentLink = newLink;
      }, 50);
    },
  },
  props: [
    'participant',
    'live',
    'type',
    'link',
    'name',
    'page',
    'viewer',
    'index',
    'loading',
    'room',
  ],
  methods: {
    // eslint-disable-next-line no-unused-vars
    findOut(num) {
      this.$emit('numpages', num);
    },
    emitReconnect() {
      this.$emit('reconnect');
      this.reconnecting = true;
      setTimeout(() => {
        this.reconnecting = false;
      }, 1000);
    },
    trackRender() {
      if (this.isPdf) {
        this.rendering = true;
        const element = document.getElementsByClassName('annotationLayer')[0];
        const interval = setInterval(() => {
          if (!element) clearInterval(interval);
          if (element.style.visibility !== 'hidden') {
            this.rendering = false;
            clearInterval(interval);
          }
        }, 50);
      }
    },
    urlParam(url, param) {
      let urlParam = '';
      if (url.indexOf(param) > -1) {
        urlParam = this.urlVars(url)[param];
      }
      return urlParam;
    },

    urlVars(url) {
      const vars = {};
      url.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
        vars[key] = value;
      });
      return vars;
    },
    dismissInitialLoading() {
      this.initialLoading = false;
      this.trackRender();
    },
  },
  created() {
    if (this.isKeynote && this.isPdf) {
      this.initialLoading = true;
    }
  },
  computed: {
    isImage() {
      const formats = ['jpg', 'png', 'jpeg', 'heic', 'gif'];
      return (
        // eslint-disable-next-line operator-linebreak
        this.isKeynote &&
        // eslint-disable-next-line operator-linebreak
        this.name &&
        formats.some(format => this.name.toLowerCase().endsWith(format))
      );
    },
    isPdf() {
      return (
        this.isKeynote && this.name && this.name.toLowerCase().endsWith('pdf')
      );
    },
    isWebsite() {
      const protocols = ['http://', 'https://'];
      return (
        // eslint-disable-next-line operator-linebreak
        this.isKeynote &&
        // eslint-disable-next-line operator-linebreak
        this.name &&
        protocols.some(protocol => this.name.includes(protocol))
      );
    },
    isRenderableWebsite() {
      const enabledHosts = [
        'docs.google.com',
        'collboard.com',
        'youtube.com',
        'youtu.be',
      ];
      return (
        // eslint-disable-next-line operator-linebreak
        this.isKeynote &&
        // eslint-disable-next-line operator-linebreak
        this.name &&
        enabledHosts.some(host => this.name.includes(host))
      );
    },
    isKeynote() {
      return this.type === 'keynote';
    },
    isTeacher() {
      return !this.$route.params.viewer;
    },
    isViewerConnected() {
      return this.viewer.connected;
    },
    ensureFormat() {
      let id = '';
      if (this.link.includes('youtu.be')) {
        const parts = this.link.split('/');
        id = parts[parts.length - 1];
      } else if (this.link.includes('youtube.com')) {
        id = this.urlParam(this.link.replace(/watch/g, ''), 'v');
      }

      if (id) {
        return `https://www.youtube.com/embed/${id}`;
      }
      return this.link;
    },
  },
};
</script>

<style lang="scss">
.annotationLayer {
  visibility: visible !important;
}
@keyframes spin {
          from {transform:rotate(0deg);}
          to {transform:rotate(360deg);}
}
.lesson-window {
  &__reconnect-icon {
    font-size: 16px !important;
    color:#8b8b9d;
    &--rotate {
      animation: spin 1s infinite linear;
    }
  }
  &__reconnect {
    cursor: pointer;
  }
}
.page,
.canvasWrapper,
.canvasWrapper canvas,
.lesson-window--image {
  width: 100% !important;
  height: auto !important;
}

.lesson-window--websiteLink {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 50%;
  text-align: center;
}

iframe {
  width: 100%;
  height: 480px;
  @media only screen and (max-width: 1468px) {
    height: 360px !important;
  }
  body {
    margin: 0;
  }
}
</style>
